import { createSelector, createFeatureSelector } from '@ngrx/store';

import { AppState, SiteState } from '../shared/models';

export const selectAppState = createFeatureSelector<AppState>('app');

// example selector
export const selectSomething = createSelector(selectAppState, (store: AppState) => store.someValue);
export const selectApp = (state: SiteState) => state.app;

export const selectLastSuccessfulManureOfferPost = createSelector(
  selectApp,
  (state: AppState) => state?.lastSuccessfulManureOfferPost,
);

export const selectLastSuccessfulManureRequestPost = createSelector(
  selectApp,
  (state: AppState) => state?.lastSuccessfulManureRequestPost,
);
